import React, { useRef } from "react";
import { months } from "../../../Utilitie";
import DownloadExcel from "../../../Extra/DownloadExcel";
const tableHead = ["Wagon", "ML Ton", "Freight Cr"];
const SAMonthWiseMaster = ({ data }) => {
  const tableRef = useRef();
  let years = [...new Set(data.map((o) => o.F_YEAR))].sort(
    (a, b) => b.replace("_", "") - a.replace("_", "")
  );
  const monthsInData = [...new Set(data.map((o) => o.A_MONTH))];
  return (
    <div className="fade-in-up">
      <div className="table-responsive">
        <table
          className="table newUiTable table-striped table-hover"
          ref={tableRef}
          style={{ fontSize: "11.5px", fontWeight: "bold" }}
        >
          <thead className="">
            <tr>
              <th rowSpan={2} style={{ width: "100px" }}>
                Sn
              </th>
              <th rowSpan={2} style={{ width: "100px" }}>
                Month
              </th>
              {years.map((year, i) => {
                return (
                  <th colSpan={3} key={i} style={{ minWidth: "100px" }}>
                    {year}
                  </th>
                );
              })}
            </tr>
            <tr>
              {years.map((year, i) =>
                tableHead.map((head, j) => {
                  return (
                    <th key={j} style={{ width: "100px" }}>
                      {head}
                    </th>
                  );
                })
              )}
            </tr>
          </thead>
          <tbody>
            {data &&
              years &&
              monthsInData.map((month, k) => {
                return (
                  <tr key={k}>
                    <td>{k + 1}</td>
                    <td>{month}</td>
                    {years?.map((y, a) => {
                      let yearWiseData = data?.filter((o) => {
                        return (
                          o.F_YEAR === y &&
                          o.A_MONTH.toLowerCase().slice(0, 3) ===
                            month.toLowerCase().slice(0, 3)
                        );
                      });
                      return (
                        <React.Fragment key={a}>
                          <td>
                            {yearWiseData.length > 0
                              ? yearWiseData.reduce((sum, obj) => {
                                  return sum + (Number(obj.WAGON) || 0);
                                }, 0)
                              : "-"}
                          </td>
                          <td>
                            {" "}
                            {yearWiseData.length > 0
                              ? (
                                  yearWiseData.reduce((sum, obj) => {
                                    return sum + (Number(obj.CH_WEIGHT) || 0);
                                  }, 0) / 1000000
                                ).toFixed(2)
                              : "-"}
                          </td>
                          <td>
                            {yearWiseData.length > 0
                              ? (
                                  yearWiseData.reduce((sum, obj) => {
                                    return sum + (Number(obj.FREIGHT) || 0);
                                  }, 0) / 10000000
                                ).toFixed(2)
                              : "-"}
                          </td>
                        </React.Fragment>
                      );
                    })}
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      <DownloadExcel tableRef={tableRef} fileName={`7A loading month wise`} />
    </div>
  );
};
export default SAMonthWiseMaster;
